import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

export const Comment = styled.div`
  box-sizing: border-box;
  display: flex;
  padding: 0.5rem 1.5rem;
  width: 100%;
`;

export const CommentGutter = styled.div`
  width: 2.75rem;
  flex-shrink: 0;
`;

export const CommentContent = styled.div`
  min-width: 0;
  padding: 0;
  white-space: pre-wrap;
  width: 100%;
  > * {
    margin: 0;
    margin-bottom: 0.5rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const CommentHeader = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  min-height: 1.72rem;
`;

export const CommentAuthor = styled.span`
  flex-shrink: 0;
  font-weight: bold;
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CommentCreatedAt = styled.span`
  color: ${colors.grayA};
  flex-grow: 1;
  font-size: 0.9rem;
  margin-left: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
